import type { BanDich } from '../types';
import type { viGiaAi } from './gia-ai.vi';

export const enGiaAi: Pick<BanDich, keyof typeof viGiaAi> = {
  giaAi: {
    tabBangGia: 'Cost prices',
    tabTyGia: 'Exchange rates',
    ban: 'You',

    loaiToken: {
      dau_vao: 'Input tokens',
      dau_vao_anh: 'Image input tokens',
      dau_vao_tool: 'Tool input tokens',
      dau_vao_dem: 'Cache read tokens',
      ghi_dem: 'Cache write tokens',
      dau_ra: 'Output tokens',
      suy_luan: 'Reasoning tokens',
    },
    loaiTokenNgan: {
      dau_vao: 'Input',
      dau_vao_anh: 'Image',
      dau_vao_tool: 'Tool',
      dau_vao_dem: 'Cache read',
      ghi_dem: 'Cache write',
      dau_ra: 'Output',
      suy_luan: 'Reasoning',
    },

    hieuLuc: {
      chuaToi: 'Not yet effective',
      chuaToiMo: 'This row takes effect in the future. No call is costed with it yet, and it will close the current row at exactly that time.',
      dangApDung: 'In effect',
      daDong: 'Closed',
      biThay: 'Replaced',
      biThayMo: 'Another row entered later with the same effective time replaced this one. No call is costed with this row.',
    },

    bang: {
      chonCheDo: 'Choose view',
      dangHieuLuc: 'In effect',
      lichSu: 'Price history',
      locMoHinh: 'Filter by model name',
      locMoHinhGoiY: 'Actual model name, press Enter',
      locMoHinhMo: 'Enter an actual model name (for example gemini-2.5-pro) to see the price rows whose pattern matches it.',
      themDongGia: 'Add price row',
      giaiThichVon: 'What providers charge the platform. Tenants never see this table.',
      khongSuaDe: 'Saved prices cannot be edited: to change a price, add a new row with an effective time; the old row closes at that time.',
      chiXem: 'You can only view cost prices. Only a Platform Admin can add price rows.',
      captionVon: 'Platform cost prices',
      cotMoHinh: 'Model pattern',
      cotDonVi: 'Unit',
      cotHieuLucTu: 'Effective from',
      cotHieuLucDen: 'Effective until',
      cotNguoiTao: 'Created by',
      cotLyDo: 'Reason for change',
      moiTinhNang: 'All features',
      bacGia: 'Tier from {{so}} input tokens',
      donViRutGon: '{{tien}} / {{so}} tokens',
      conMo: 'Open',
      giaMuon: '(= {{tu}} price)',
      giaMuonMo: 'No price of its own: calls are costed at the {{tu}} price.',
      giaKhongKhai: 'No price entered and no price to fall back on.',
      doiGia: 'Change price',
      doiGiaCua: 'Change price of {{mau}}',
      loiTai: 'Could not load cost prices. {{loi}}',
      rongThat: 'No price rows yet',
      rongThatMo: 'Model calls without a cost price are recorded as unpriced. Add the first price row for a model in use.',
      rongThatChiXem: 'Model calls without a cost price are recorded as unpriced. Only a Platform Admin can add price rows.',
      rongHieuLuc: 'No price rows are in effect or upcoming',
      rongLocMoHinh: 'No price rows match {{mo_hinh}}',
      dangHien: 'Rows shown: {{so}}',
      dangHienHieuLuc: 'Rows in effect or upcoming: {{so}} of {{tong}} in the history',
    },

    form: {
      tieuDeThemVon: 'Add cost price row',
      tieuDeDoiVon: 'Change cost price: add a new version',
      khongSuaDe: 'Saved prices cannot be edited. To change a price, add a new row with an effective time.',
      nhomMoHinh: 'Model and effective time',
      moHinh: 'Model',
      chonMoHinh: 'Search by name or real model name',
      khongCoModel: 'No matching model',
      danhMucRong: 'The AI model catalogue has no models yet',
      chuaCoTenThat: 'No real model name — set it on the AI models screen',
      loiDanhMuc: 'Could not load the AI model catalogue: {{loi}}',
      nhapMau: 'Enter a pattern for a model family',
      chonTuDanhMuc: 'Choose from the AI model catalogue',
      mauMoHinh: 'Model name pattern',
      mauMoHinhGoiY: 'qwen2.5-7b*',
      nhaCungCap: 'Provider',
      nhaCungCapGoiY: 'Choose a provider',
      theoModel: 'Set by the chosen model',
      donViTien: 'Currency',
      hieuLucTu: 'Effective from',
      nhomGia: 'Unit prices',
      donGiaTren: 'Price per {{so}} tokens, in {{tien}}.',
      oTrongAnGia: 'Empty = {{tu}}',
      lyDo: 'Reason for change',
      nangCao: 'Advanced options',
      donViToken: 'Price per how many tokens',
      tinhNang: 'Feature',
      nguongDauVao: 'Input token threshold',
      khongChiaBac: 'No tiers',
      oGiaGiuNguyen: 'The model pattern, feature and tier stay the same when changing a price.',
      xemLaiRoiLuu: 'Review and save',
      xacNhanVon: 'Add a cost price row for {{mau}}?',
      xacNhanThan: 'The row takes effect from {{moc}}. The row in effect for the same price cell closes at that time. This cannot be undone: rows can only be added, not edited or deleted; if you enter something wrong, add a correct row.',
      daThem: 'Price row added for {{mau}}.',
      loiTrong: 'This field cannot be empty.',
      loiQuaDai: 'At most {{so}} characters.',
      loiGiaSai: 'Enter a non-negative number with at most six decimal places.',
      loiSoNguyen: 'Enter a positive whole number, for example 1000000.',
      loiThieuMoc: 'Choose an effective time.',
      loiMocQuaKhu: 'The effective time cannot be in the past. Choose a time from now on.',
      loiThieuGia: 'Enter a price for at least one token type, usually Input tokens and Output tokens.',
      loiChonModel: 'Choose a model.',
      loiChonNhaCungCap: 'Choose a provider.',
      loiDonViTien: 'Choose a currency.',
      loiTheoO: 'The server rejected some fields. Fix the fields marked above and save again.',
    },

    tyGia: {
      moTa: 'Daily exchange rates used to convert cost prices entered in a foreign currency into the reporting currency.',
      khongSuaDe:
        'The exchange rate table only allows adding: a new row closes the previous row of the same conversion, and there is no edit function. Rates are recorded per day, not per hour.',
      chiXem: 'You can only view exchange rates. Only a Platform Admin can add exchange rate rows.',
      themTyGia: 'Add exchange rate',
      doiTyGia: 'Change exchange rate',
      doiTyGiaCua: 'Change {{tu}} to {{den}} exchange rate',
      caption: 'Exchange rates by conversion',
      cotChieu: 'Conversion',
      soPhienBan: 'Versions: {{so}}',
      phienBanCu: 'Previous version',
      tyGia: 'Exchange rate',
      tyGiaGoiY: '25400',
      tyGiaMo: 'How many {{den}} one {{tu}} is worth. Must be greater than 0, with at most six decimal places.',
      hieuLucTuNgay: 'Effective from date',
      hieuLucTuNgayMo: 'The row in effect for the same conversion closes on exactly this date.',
      denNgay: 'Effective until date',
      donViGoc: 'From currency',
      donViDich: 'To currency',
      lyDo: 'Source or reason',
      lyDoMo: 'Source of the rate, or the reason for the change. Shown in the table.',
      loiTai: 'Could not load exchange rates. {{loi}}',
      loiTyGia: 'The exchange rate must be a number greater than 0 with at most six decimal places.',
      loiCungDonVi: 'The target currency must differ from the source currency.',
      loiThieuNgay: 'Choose an effective date.',
      daThem: 'Exchange rate {{tu}} to {{den}} added.',
      xacNhanQuaKhuTieuDe: 'Add a {{tu}} to {{den}} exchange rate effective from {{ngay}}, a date in the past?',
      xacNhanQuaKhuThan: 'Cost already recorded for calls since {{ngay}} does not change to the new rate. Once added, it cannot be edited or deleted; if you enter something wrong, add a correct row.',
      xacNhanQuaKhuNut: 'Add exchange rate from {{ngay}}',
      rongThat: 'No exchange rates yet',
      rongThatMo: 'No exchange rate is needed if every cost price row is in the reporting currency. Add one when a model is priced in a foreign currency.',
      rongThatChiXem: 'No exchange rate is needed if every cost price row is in the reporting currency. Only a Platform Admin can add exchange rate rows.',
    },
  },
};
